<div id="request-management" class="page-layout simple left-sidebar inner-sidebar inner-scroll">

    <!-- HEADER -->
    <div class="header accent p-16 p-sm-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-xs="row"
        fxLayoutAlign.gt-xs="space-between center">

        <!-- APP TITLE -->
        <div fxLayout="row" fxLayoutAlign="start center">

            <div class="logo" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon mr-16" [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
                    description
                </mat-icon>
                <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                    {{'Requests' | translate }}
                </span>
            </div>

        </div>
        <!-- / APP TITLE -->

        <!-- SEARCH -->
        <div class="ml-sm-32" fxLayout="row" fxLayoutAlign="end center" fxFlex>

            <!-- <div class="search-wrapper mt-16 mt-sm-0"> -->

                <div class="search-wrapper mt-16 mt-sm-0">
                    <!-- <mat-icon>search</mat-icon>
                    <input [formControl]="searchInput" placeholder="Search for a project"> -->
                    <button mat-raised-button  (click)="newRequest()">
                        <span>{{'Send New Request' | translate }}</span>
                    </button>
                </div>

            <!-- </div> -->

        </div>
        <!-- / SEARCH -->

    </div>
    <!-- / HEADER -->

    <!-- SELECTED BAR -->
    <!-- <selected-bar class="accent-600" *ngIf="hasSelectedContacts" [@slideInTop]></selected-bar> -->
    <!-- / SELECTED BAR -->

    <!-- CONTENT -->
    <div class="content">

        <!-- CENTER -->
        <div class="center p-24 pb-56" fusePerfectScrollbar>

            <!-- CONTENT -->
            <div class="content">
                <!-- <user-list></user-list> -->
                <request-list></request-list>
            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CENTER -->

    </div>
    <!-- / CONTENT-->

</div>
<!-- <button mat-fab class="accent" id="add-request-button" aria-label="add country"
    [@animate]="{value:'*', params:{delay:'300ms',scale:'.2'}}" (click)="newRequest()">
    <mat-icon>add</mat-icon>
</button> -->

